import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin } from 'lucide-react';
import { useApp } from '../context/AppContext';
import { galleryImages } from '../mock/mock';
import { slugify } from '../mock/guides';

const Gallery = () => {
  const { lang } = useApp();
  const heading = {
    en: 'We provide a unique transfer experience, every time.',
    de: 'Wir bieten jedes Mal ein einzigartiges Transfer-Erlebnis.',
    fr: 'Nous offrons une expérience de transfert unique, à chaque fois.',
  }[lang];
  const sub = {
    en: 'Not only will your driver ensure you arrive safely, they will also be your first introduction to a new destination.',
    de: 'Ihr Fahrer sorgt nicht nur für eine sichere Ankunft, sondern ist auch Ihre erste Einführung in ein neues Ziel.',
    fr: 'Votre chauffeur assure non seulement votre arrivée en toute sécurité, mais est aussi votre première introduction à une nouvelle destination.',
  }[lang];
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="max-w-3xl mb-12">
          <h2 className="text-3xl sm:text-4xl font-extrabold text-[color:var(--brand-dark)]">{heading}</h2>
          <p className="mt-4 text-gray-500 leading-relaxed">{sub}</p>
        </div>
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
          {galleryImages.map((g, i) => (
            <Link to={`/guide/${slugify(g.label)}`} key={i} className={`card-hover relative rounded-2xl overflow-hidden group block ${i % 2 === 0 ? 'lg:mt-8' : ''}`} data-testid={`gallery-card-${i}`}>
              <img src={g.img} alt={g.label} className="w-full h-64 object-cover transition-transform duration-500 group-hover:scale-110" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
              <div className="absolute bottom-3 left-3 flex items-center gap-1.5 text-white text-sm font-semibold">
                <MapPin className="w-4 h-4" style={{ color: 'var(--brand-accent)' }} /> {g.label}
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Gallery;
